import { BuildJoinedBySlashProps } from "../../../../../../../models/list/export"

export const buildJoinedBySlash = <T>({
  data,
  fields,
}: BuildJoinedBySlashProps<T>): Record<string, string> =>
  fields.reduce((previousKey, { key, fn, alias }) => {
    let str = ""

    data.forEach((item, index) => {
      if (index) str += "/"

      const value = item[key]
      str += fn ? fn(value) : (value as string)
    })

    previousKey[alias ?? (key as string)] = str

    return previousKey
  }, {} as Record<string, string>)
